import { useState, useEffect } from "react";
import api from "../../api/axios";

import {
  Divider,
  Box,
  Chip,
  Grid,
  Fade,
  ButtonGroup,
  Button,
  Typography,
  FormControl,
} from "@mui/material";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { pdfjs } from "react-pdf";
import LoadPdf from "./LoadPdf/LoadPdf";

import {
  CommonSubHeader,
  useLocationHelpers,
  NavButton,
} from "../../Components/helpers/Helpers";
import { useSearchParams } from "react-router-dom";
import { FormLabel } from "react-bootstrap";
import { MenuBook } from "@mui/icons-material";
// Configuración del worker de PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

const Ver = () => {
  const { goPanel, goTable, goEdit, buildEditUrl, buildTableUrl } =
    useLocationHelpers();
  // Obtener bookId desde query string
  const [searchParams] = useSearchParams();
  const bookId = searchParams.get("id");

  // Estados
  const [bookName, setBookName] = useState("");
  const [bookDescription, setBookDescription] = useState("");
  const [book, setBook] = useState("");
  const [tags, setTags] = useState([]);
  const [flag, setFlag] = useState(false);

  // Funciones

  const textareaStyle = {
    resize: "none", // Evitar el cambio de tamaño
    border: "none", // Eliminar los bordes
    padding: "10px", // Espacio interno
    fontSize: "13px", // Tamaño de la fuente
    width: "100%", // Ocupa el ancho completo
    height: "100px", // Altura ajustable
    outline: "none", // Eliminar el borde de enfoque
    boxShadow: "none", // Eliminar cualquier sombra de caja
  };

  // Generar un color aleatorio
  const getRandomDarkColor = () => {
    const r = Math.floor(Math.random() * 128);
    const g = Math.floor(Math.random() * 128);
    const b = Math.floor(Math.random() * 128);
    return `rgb(${r}, ${g}, ${b})`;
  };

  const chipsStyles = {
    margin: 4,
    padding: "15px",
    boxShadow: "0px 0px 7px 0px gray",
    borderRadius: "10px",
  };

  // Obtener los datos del libro
  const getData = async () => {
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/library/show`,
        { libro: bookId },
      );

      const bookData = data?.book ?? {};

      setBook(bookData);

      // Usa el campo correcto para el archivo PDF (puede ser file, doc_file, etc.)
      const fileName = bookData.file || bookData.doc_file || "";
      setBookName(fileName);

      // Descripción segura (sin romper si viene null o undefined)
      const description = (bookData.description || "").replace(
        /<br\s*\/?>/gi,
        "\n",
      );
      setBookDescription(description);

      // Manejo seguro de tags
      const rawTags = bookData.tags || "";
      const tagsArray = rawTags.includes(",")
        ? rawTags.split(",")
        : rawTags
          ? [rawTags]
          : [];
      setTags(tagsArray);

      setFlag(true);
    } catch (error) {
      console.error("   Error al obtener el libro:", error);
      setFlag(false);
    }
  };

  // Cargar datos al montar el componente
  useEffect(() => {
    getData();
  }, [bookId]);

  return (
    <div>
      <CommonSubHeader title="Biblioteca" subTitle="Ver" />

      <Fade timeout={600} in={flag}>
        <Box
          sx={{
            maxWidth: "1000px",
            margin: "auto",
            background: "white",
            borderRadius: "12px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
            p: 4,
            mb: 3,
          }}
        >
          {/* TITLE */}
          <Typography
            variant="h4"
            sx={{
              textAlign: "center",
              fontWeight: 700,
              mb: 2,
            }}
          >
            {book.title}
          </Typography>

          <Divider sx={{ mb: 3 }} />

          {/* TAGS */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 1,
              mb: 3,
            }}
          >
            {tags.map((tag, index) => (
              <Chip
                key={index}
                label={tag.toUpperCase()}
                sx={{
                  fontWeight: 600,
                  borderRadius: "8px",
                  background: "#eef4ff",
                  color: "#2b5cff",
                }}
              />
            ))}
          </Box>

          {/* DESCRIPTION */}
          <Box
            sx={{
              background: "#fafafa",
              border: "1px solid #e5e5e5",
              borderRadius: "10px",
              p: 3,
              lineHeight: 1.7,
              fontSize: "14px",
              whiteSpace: "pre-line",
              color: "#444",
            }}
          >
            {bookDescription}
          </Box>

          {/* ACTIONS */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              mt: 4,
            }}
          >
            <NavButton
              variant="contained"
              color="info"
              to={buildEditUrl("biblioteca", bookId)}
              onClick={() => goEdit("biblioteca", bookId, "Libro")}
            >
              Editar
            </NavButton>

            <NavButton
              variant="outlined"
              color="error"
              to={buildTableUrl("biblioteca")}
              onClick={() => goTable("biblioteca", "Biblioteca")}
            >
              Volver a tabla
            </NavButton>
          </Box>
        </Box>
      </Fade>

      {/* PDF */}
      {bookName !== "" && (
        <Box
          sx={{
            maxWidth: "1000px",
            margin: "auto",
            background: "white",
            borderRadius: "12px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
            p: 4,
            mb: 3,
          }}
        >
          <Chip
            icon={<MenuBook color="info" />}
            label="Libro"
            sx={{
              fontWeight: 600,
              fontSize: "13px",
              px: 1,
              borderRadius: "8px",
              background: "linear-gradient(135deg,#eef3ff,#f8faff)",
              color: "#3f51b5",
              border: "1px solid rgba(63,81,181,0.25)",
              boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
            }}
          />
          {bookName !== "" && <LoadPdf bookName={bookName} bookId={bookId} />}
        </Box>
      )}
    </div>
  );
};

export default Ver;
